import CAAA1050ResponseModel from '@/api/data/CAA/CAAA1050/CAAA1050ResponseModel'
import CAAA1050RequestModel from '@/api/data/CAA/CAAA1050/CAAA1050RequestModel'
import RestService from '@/common/RestService'
import ApiUrlConstants from '@/common/ApiUrlConstants'

export default class CAAG1050Service {
  /**
   * CAAA1050 API処理呼出
   * @return caaa1050ResponseModel [ApiUrlConstants.CAAA1050]APIからのレスポンスデータ
   */
  public async callAPICAAA1050(id): Promise<CAAA1050ResponseModel> {
    const caaa1011RequestModel = new CAAA1050RequestModel()
    caaa1011RequestModel.id = id
    const caaa1050ResponseModel: CAAA1050ResponseModel = <
      CAAA1050ResponseModel
    > await RestService.post(ApiUrlConstants.CAAA1050, caaa1011RequestModel)
    return caaa1050ResponseModel
  }
}
